import { useMutation } from '@tanstack/react-query';
import { v1EventFormSubmissionsApi } from '../api/v1/eventFormSubmissions';
import type { FormSubmissionResult, FormResponses } from '../types/publicForm.types';

export const useSubmitV1EventForm = () => {
  return useMutation<FormSubmissionResult, Error, { 
    eventSlug: string; 
    formSlug: string; 
    data: any;
  }>({
    mutationFn: ({ eventSlug, formSlug, data }) => 
      v1EventFormSubmissionsApi.submitForm(eventSlug, formSlug, data),
  });
};